/**
* Skipping Image Three Column JS
* -----------------------------------------------------------------------------
*
* All the JS for the Skipping Image Three Column component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'skipping-image-three-column',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.skipping-image-three-column' ).each( function( key, component ) {
        const inner = $( '.skipping-image-three-column__inner' )[0];
        const image = $( inner ).find( '.skipping-image-three-column__image-skipper' );
        const graphics = $( component ).find( '.skipping-image-three-column__graphics' );
        const imageInner = $( inner ).find( '.skipping-image-three-column__image-inner' );

        const image0 = $( inner ).find( '.skipping-image-three-column__image--0' )[0];
        const image1 = $( inner ).find( '.skipping-image-three-column__image--1' )[0];
        const image2 = $( inner ).find( '.skipping-image-three-column__image--2' )[0];
        const image3 = $( inner ).find( '.skipping-image-three-column__image--3' )[0];
        const image4 = $( inner ).find( '.skipping-image-three-column__image--4' )[0];

        const pinner = gsap.timeline( {
          scrollTrigger: {
            trigger: inner,
            pin: true,
            start: 'top top',
            end: '+=' + ( window.innerHeight * 3 ),
            pinSpacing: false,
            scrub: 0.5,
          },
        } );

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: inner,
            start: 'top top',
            end: '+=' + ( window.innerHeight * 2 ),
            onUpdate: function( e ) {
              if ( e.progress == 1 ) {
                $( '.skipping-image-three-column__content-row' ).addClass( 'is-active' );
              } else {
                $( '.skipping-image-three-column__content-row' ).removeClass( 'is-active' );
              }
            },
            scrub: 1,
          },
        } );

        const graphicsPinner = gsap.timeline( {
          scrollTrigger: {
            trigger: graphics,
            pin: true,
            start: 'top top',
            end: '+=' + ( window.innerHeight * 2 ),
            scrub: 2,
          },
        } );

        const imageWidth = 154;
        const imageHeight = 100;
        const clipLeft = ( document.documentElement.clientWidth - imageWidth ) / 2;
        const clipRight = ( document.documentElement.clientWidth - imageWidth + 24 ) / 2;
        const clipTop = ( window.innerHeight - imageHeight ) / 2;
        const clipBottom = ( window.innerHeight - imageHeight ) / 2;
        const scaleAmount = ( imageWidth + 32 ) / window.innerWidth;

        tl.to( image1, {opacity: 1, ease: 'linear', duration: 0.075} );
        tl.to( image2, {opacity: 1, ease: 'linear', duration: 0.075} );
        tl.to( image3, {opacity: 1, ease: 'linear', duration: 0.075} );
        tl.to( image4, {opacity: 1, ease: 'linear', duration: 0.075} );

        tl.fromTo( image, {clipPath: 'inset(' + clipTop + 'px ' + clipRight + 'px ' + clipBottom + 'px ' + clipLeft + 'px)'}, {clipPath: 'inset(0px 0px 0px 0px)', ease: 'linear'}, 0 );
        tl.fromTo( imageInner, {scale: scaleAmount}, {scale: 1, ease: 'linear'}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'skipping-image-three-column', COMPONENT );
} )( app );
